<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main" v-infinite-scroll="load" infinite-scroll-delay="200" infinite-scroll-distance="200">
        <SubTitleComponent :title="title" :type="'client'"></SubTitleComponent>
        <div class="box">
          <div class="filter">
            <el-tag class="item" type="success" :effect="styleCur == -1 ? 'dark' : 'plain'" @click="onChange(-1)">全部</el-tag>
            <el-tag class="item" type="success" v-for="(item, index) in styleData" :key="index" :effect="styleCur == index ? 'dark' : 'plain'" @click="onChange(index)">{{ item.style_type }}</el-tag>
          </div>
          <!-- <div class="waterfall"> -->
            <waterfall class="waterfall" :col="4" :gutterWidth="20" :data="materialData" :lazyDistance="200">
              <template>
                <div v-for="(item, index) in materialData" :key="index" class="waterfall-item">
                  <img :src="item.photo_url" class="image" @click="toDetail(index)">
                  <!-- <div class="name">{{ item.style_type + item.material_id }}</div> -->
                   <div class="name">&nbsp;</div>
                  <div :class="item.is_vote == 1 ? 'vote on' : 'vote'">{{ item.vote }}</div>
                </div>
              </template>
            </waterfall>
            <!-- <div v-for="(item, index) in materialData" :key="index" class="waterfall-item">
              <img :src="item.photo_url" class="image" @click="toDetail(index)">
              <div class="name">{{ item.style_type + item.material_id }}</div>
              <div :class="item.is_vote == 1 ? 'vote on' : 'vote'">{{ item.vote }}</div>
            </div> -->
          <!-- </div> -->
        </div>
        <el-dialog
          :visible.sync="dialogVisit"
          width="60%"
          :show-close="false"
          center>
          <div class="img">
            <img v-if="dialogCur != -1" :src="materialData[dialogCur].photo_url" alt="">
          </div>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="toCancel">返回</el-button> -->
            <!-- <el-button v-if="dialogCur != -1" @click="toVote" :icon="materialData[dialogCur].is_vote == 0 ? 'el-icon-star-off' : 'el-icon-star-on'">{{ materialData[dialogCur].is_vote == 0 ? '点赞' : '取消点赞' }}</el-button> -->
            <el-button v-if="dialogCur != -1" @click="toVote" :icon="materialData[dialogCur].is_vote == 1 ? 'el-icon-like-on' : 'el-icon-like'">点赞</el-button>
            <!-- <el-button v-if="dialogCur != -1" @click="toVote" :icon="'el-icon-star-on'">点赞</el-button> -->
            <el-button @click="toPath">生成同款</el-button>
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>

let _ajaxType = 0

export default {
  name: 'Index',
  components: {},
  data() {
    return {
      title: '',
      searchInput: '',
      styleData: [],
      styleCur: -1,
      materialData: [],
      dialogVisible: '',
      dialogVisit: false,
      dialogCur: -1,
      voteType: true,
      page: 0,
      pagesize: 100,
      allpage: 0
    }
  },
  mounted() {
    this.page = 0
    this.allpage = 0
    this.materialData = []
    console.log("index", this.global)
    this.title = this.global.clientName
    _ajaxType = 0
    this.getStyle()
  },
  methods: {
    load () {
      // this.getStyle()
    },
    getStyle() {
      let _url = "/api/?mod=material_style"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("styleData", _data);
        if (json.data.errcode == 0) {
          // this.styleCur = _data.result[0].style_type
          this.styleData = _data.result
          this.getData()
        }
        console.log(json.data);
      })
    },
    getData() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _url = "/api/?mod=material&action=recommend"
        let _style = ''
        if(this.styleCur >= 0){
          _style = this.styleData[this.styleCur].style_type
        }
        let _materialData = {
          style_type: _style,
          page: _page + 1,
          pagesize: this.pagesize,
        }
        // console.log(this.axios)
        this.axios.post(_url, _materialData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("materialData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            this.materialData = [...this.materialData, ..._data.result]
          }
          console.log(json.data);
        })
      }
    },
    toDetail(cur) {
      this.dialogCur = cur
      this.dialogVisit = true
    },
    toPath() {
      this.$router.push({ path: '/effectsave' })
    },
    onChange(cur) {
      this.styleCur = cur
      this.materialData = []
      this.page = 0
      this.allpage = 0
      this.getData()
    },
    toVote() {
      let _url = "/api/?mod=material&action=vote"
      let _material = [...this.materialData]
      let _id = _material[this.dialogCur].material_id
      let _vote = {
        material_id: _id
      }
      this.axios.post(_url, _vote).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("voteData", _data);
        if (json.data.errcode == 0) {
          _material[this.dialogCur].is_vote = 1
          _material[this.dialogCur].vote = _material[this.dialogCur].vote + 1
          this.materialData = _material
        }
        console.log(json.data);
      })
    },
    toCancel() {
      this.dialogVisit = false
    },
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .filter {
      margin-bottom: 10px;
      font-size: 0;
      .item {
        margin: 0 10px 10px 0;
      }
    }
    .waterfall {
      // column-count: 4; /* 设置列数 */
      // column-gap: 20px; /* 设置列间距 */
    }
    .waterfall-item {
      position: relative;
      // break-inside: avoid-column; /* 防止内容在列中断开 */
      margin-bottom: 20px; /* 底部间距 */
      padding: 0;
      .name {
        padding-left: 10px;
        line-height: 30px;
      }
      .vote {
        position: absolute;
        bottom: 0;
        right: 10px;
        padding-left: 20px;
        background: url(../assets/ico_vote.png) no-repeat;
        background-size: auto 15px;
        background-position: 0 7px;
        line-height: 30px;
        &.on {
          background-image: url(../assets/ico_vote_on.png);
        }
      }
    }
    .image {
      width: 100%; /* 图片宽度占满列宽 */
      display: block; /* 防止图片下方有空隙 */
      border-radius: 10px;
    }
  }
}
.el-dialog {
  .img {
    text-align: center;
    img {
      max-height: 300px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/IndexClient.vue